import React, { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import styles from "./ViewFeedbackDetails.module.css";
import ReceiptDetails from "./ReceiptDetails";
import ResolutionDetails from "./ResolutionDetails";
import SlaDetails from "./SlaDetails";
import CommentDetails from "./CommentDetails";
import CustomerSatisfaction from "./CustomerSatisfaction";
import { useTranslation } from "react-i18next";
import useAxiosFetchData from "../../../hooks/useAxiosFetchData";
import AcceptFeedback from "../../basic-component/form-component/feedback-form/AcceptFeedback";
import { IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import Snackbar from "@mui/material/Snackbar";
import FeedbackClosure from "../../basic-component/form-component/feedback-form/FeedbackClosure";
import FeedBackDetails from "./FeedBackDetails";
import AttachmentFile from "../../../../../src/assets/images/attachment-file.svg";
import { setReloadFeedbackDetails } from "../../../system/redux/reducers/reloadFeedbackDetails";
// import { useDispatch } from "react-redux";

// Bootstrap
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { CardBody } from "react-bootstrap";
import ContactInfo from "./ContactInfo";
import MailReply from "./MailReply";
import ReactModal from "../../basic-component/Modal/AddModalCustomer";
import useModal from "../../../hooks/useModal";
import { getCustomerFeedbackDetailsURL } from "../../../../constants/constants";
import Historytimeline from "./Historytimeline";
import AttachmentFileDetails from "./AttachmentFileDetails";
import PageHeadContainer from "../../basic-component/PageHeadContainer";
import DashboardButtonCard from "../../basic-component/dashboard/DashboardButtonCard";
import HeaderCard from "../../basic-component/dashboard/HeaderCard";
import PluginSnackbar from "../../basic-component/Snackbar";
import CustomerSatisfactionResponse from "./CustomerSatisfactionResponse";
import CloseFeedback from "../../roles/spoc/feedback/CloseFeedback";
const ViewFeedbackDetails = (props) => {
  debugger;
  console.log(props.body.id);
  const { t } = useTranslation();
  const { csrfHeaderName, csrfFormTagName, csrfToken } = useSelector(
    (state) => state.csrf
  );
  const roles = useSelector((state) => state.role.userCurrRole.description);
  const rolesId = useSelector((state) => state.role.userCurrRole.department.id);
  const [response, setResponse] = useState(null);
  const [activeSection, setActiveSection] = useState("0");
  const [status, setStatus] = useState(null);
  const [map, setMap] = useState({});
  const [lastopen, setLastOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showFeedbackCloser, setShowFeedbackCloser] = useState(false);
  const [showAcceptbackCloser, setShowAcceptbackCloser] = useState(true);
  const [componentToRender, setComponentToRender] = useState(<></>);
  const { isShowingConsent, settoggle } = useModal({ state: false });
  const [showRate, setRate] = useState(false);
  const [payloadProps, setPayloadProps] = useState(props.body);
  const { isShowing, toggle } = useModal({ state: false });
  const [isShowingModal, toggleModal] = useState(false);
  const [resolutionModal, setResolutionModal] = useState(false);
  const [mailId, setMailId] = useState("");
  const [snackbarSwitch, setSnackbarSwitch] = useState(false);
  const [snackbarMessage1, setSnackbarMessage1] = useState("");
  const [taggedPayload, setTaggedPayload] = useState({
    id: String(props.id),
    feedbackDesc: "",
    description: "",
  });
  const [consentData, setConsentdata] = useState();
  const [customerSatisfactionResponse, setCustomerSatisfactionResponse] =
    useState(false);
  const [reciptResponse, setReciptResponse] = useState(false);
  const [slaDetails, setSladetailstoggle] = useState(false);
  const [closeFd, setCloseFd] = useState(false);
  console.log(props.body);
  console.log(payloadProps);
  // const [showRate,setRate]=useState(false);
  const [headers, setHeaders] = useState({
    "X-Csrf-Token": csrfToken,
    "Content-Type": "application/json",
  });
  const keyComponent = props.keyComponent;
  const [render, setRender] = useState(true);
  const stringifyNestedObjects = (obj) => {
    if (typeof obj === "object" && obj !== null) {
      Object.keys(obj).forEach((key) => {
        obj[key] = stringifyNestedObjects(obj[key]);
      });
    }
    return obj;
  };
  const formData = new FormData();

  const { fetchData: fetchfeedbackDetails, response: feedbackDetailsResponse } = useAxiosFetchData({
    url: props.fetchUrl,
    method: "post",
    body: payloadProps,
    headers: headers,
    onLoad: true,
  });
  const dispatch = useDispatch();
  const [x, sx] = useState(false);
  const { value: fetchAgainFlag } = useSelector(state => state.reloadFeedbackDetails);
  useEffect(() => {
    // debugger;
    window.onpopstate = (e) => {
      debugger;
      props.Dashboardtoggle(e);
    }

    if (fetchAgainFlag === true) {
      // dispatch(setRatingValue(false));
      dispatch(setReloadFeedbackDetails({ value: false }));

      //fetch details
      // debugger;
      handleContactInfoClick(props.body.id);
      // fetchfeedbackDetails().then((data)=>{
      //   console.log(data);
      // });


    }
  }, [fetchAgainFlag]);
  const role = useSelector((state) => state.role.userCurrRole.description);
  const feedbackdetails = useCallback(() => {
    const formData = {
      id: String(props.id),
      feedbackDesc: "",
      description: "",
    };
    const formDataJSON = JSON.stringify(formData);

    // axios.post(Callapi, formDataJSON, {
    //   withCredentials: true,
    //   headers
    // })
    //   .then((data) => {
    //     console.log("data", data);
    //     setResponse(data.data);
    //     const stringifiedData = stringifyNestedObjects(data.data);
    //   })
    //   .catch((error) => {
    //     console.log("Error:", error);
    //   });
  }, []);

  useEffect(() => {
    let isString = false;

    for (const key in props) {
      console.log("key:", key);
      if (props.hasOwnProperty(key)) {
        const propValue = props[key];
        console.log("propValue:", propValue);
        if (typeof propValue === "string" || typeof propValue === "number") {
          console.log("String property found:", propValue);
          isString = true;
          break; // Exit the loop since we found a string property
        }
      }
    }
    console.log("isString:", isString);
    if (!isString) {
      setResponse(props.data);
    } else {
      feedbackdetails();
      // console.log(roleMap.get(role));
      // console.log(roleMap.get(role).get('CLOSED'))
    }
  }, [props, feedbackdetails]);

  console.log(map);
  console.log(props.latestFeedbackDetails);

  const resetButtons = () => {
    setActiveSection("0");
  };

  const rateNow = () => {
    console.log("customer");
    setRate(true);
  };

  const resolutionToggle = () => {
    setResolutionModal(true);
  };
  const toggleSection = (section) => {
    resetButtons();
    setActiveSection(section);
  };
  console.log(feedbackDetailsResponse);
  const taggedFeedbackAction = (id) => {
    console.log(id);

    setTaggedPayload((prevPayload) => {
      return { ...prevPayload, ["id"]: id };
    });
    toggleModal(true);
  };
  const consentDetails = (data, options = {}) => {
    debugger;
    console.log(data);
    setConsentdata(data);
    if (data.success === true && !options?.skipModalToggle) {
      toggle();
    }
  };

  const toggleModal1 = (show) => {
    toggleModal(show);
  };
  const handleAdditionalButtonAction = () => {
    console.log(isShowingModal);
    toggleModal(false);
    toggleModal1(false);
  };
  const mailOpen = (id) => {
    // console.log(id);
    setMailId(id);
    onMailOpen(id);
  };
  const onMailOpen = (id) => {
    console.log(id);
  };
  useEffect(() => { }, [setMailId]);

  // useEffect(() => {
  //   console.log(false);
  //   handleAdditionalButtonAction();
  // }, []);

  // useEffect(() => {
  //   if(isShowingModal==false){
  //   handleAdditionalButtonAction();
  //   }
  // }, [isShowingModal]);

  const [consentTagged, setConsentTagged] = useState(true);
  const [CosnetTaggedId, setConsentTaggedId] = useState("");
  const handleConsentAction = () => {
    setConsentTagged(true);
    console.log("hello");
    toggle();
  };
  const handleConsentActiontagged = (data) => {
    console.log(data);
    setConsentTaggedId(data);
    setConsentTagged(false);
    toggle();
  };
  const customerSatisfactionStarResponse = () => {
    setCustomerSatisfactionResponse(true);
  };
  const reciptToggle = () => {
    setReciptResponse(true);
  }
  const sladetailstoggle = () => {
    setSladetailstoggle(true);
  }
  const closeFeedbackToggle = () => {
    setCloseFd(() => !closeFd);
  }
  const renderActiveSection = () => {
    // if (!feedbackDetailsResponse) {
    //   return null;
    // }
    console.log(feedbackDetailsResponse);
    debugger;
    switch (activeSection) {
      case "0":
        return <FeedBackDetails consent={consentData} data={feedbackDetailsResponse} handleFeedbackAction={rateNow} taggedFeedbackAction={taggedFeedbackAction} handleConsentAction={handleConsentAction} handleConsentActiontagged={handleConsentActiontagged} onClick={handleContactInfoClick} resolutionToggle={resolutionToggle} reciptToggle={reciptToggle} sladetailstoggle={sladetailstoggle} customerSatisfactionStarResponse={customerSatisfactionStarResponse} closeFd={closeFeedbackToggle} handleMailData= {MailList} fetchfeedbackDetails={fetchfeedbackDetails} onConsentSubmit={consentDetails}/>;
      case "1":
        return <ReceiptDetails data={feedbackDetailsResponse} />;
      case "2":
        return <ResolutionDetails data={feedbackDetailsResponse} />;
      case "3":
        return <SlaDetails data={feedbackDetailsResponse} />;
      case "4":
        return (
          <CustomerSatisfaction
            isStarEnabled={feedbackDetailsResponse.isStarEnabled}
            data={feedbackDetailsResponse}
          />
        );
      case "5":
        return (
          <CommentDetails
            data={props.feedbackDetailsResponse}
            keyComponent={props.keyComponent}
            uploadFormData={formData}
            consentDetails={consentDetails}
          />
        );
      default:
        return null;
    }
  };
  const [currentStatus, setCurrentStatus] = useState("");
  const lasthandleClose = () => {
    setLastOpen(false);
    setShowFeedbackCloser(true);
  };
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={lasthandleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  function AppropriateDateComponent({ value }) {
    const generateAppropriateDate = (value) => {
      if (value === undefined || value === null) {
        return "N/A";
      } else {
        var date = new Date(value);
        var month = date.getMonth() + 1;
        var hours = date.getHours();
        var min = date.getMinutes();
        if (min < 10) min = "0" + min;
        var ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12;
        var dd = date.getDate();
        return (
          (dd >= 10 ? dd : "0" + dd) +
          "-" +
          (month >= 10 ? month : "0" + month) +
          "-" +
          date.getFullYear() +
          " " +
          hours +
          ":" +
          min +
          " " +
          ampm
        );
      }
    };
  }
  const handleModalClose = (responseData) => {
    console.log("Feedback response:", responseData);
    setLastOpen(true);
    setSnackbarMessage(responseData);
    setShowAcceptbackCloser(false);
    setShowFeedbackCloser(true);
  };
  const [closeData, setCloseData] = useState(feedbackDetailsResponse);
  useEffect(() => {
    if (feedbackDetailsResponse) {
      // if(props.keyComponent === "Accept"){
      //   formData.append('_csrf', csrfToken);
      //   formData.append('feedbackTypeDesc', feedbackDetailsResponse.feedbackType.description);
      //   formData.append('receiptTargetId', feedbackDetailsResponse.latestReceipt.receiptTargetId);
      //   formData.append('departmentId', rolesId);
      //   formData.append('feedbackId', feedbackDetailsResponse.id);
      //   formData.append('comment', '');
      //   formData.append('_csrf', csrfToken);
      //   formData.append('fileName', '');
      //   formData.append('user.username', '');
      //   formData.append('departmentSlaId[0]', feedbackDetailsResponse.receipt.departmentSlaAssignmentList[0].departmentSlaId);
      //   formData.append('assignmentSLATime[0]', feedbackDetailsResponse.receipt.departmentSlaAssignmentList[0].minuteToCalculate);
      //   formData.append('assignmentTime', feedbackDetailsResponse.receipt.departmentSlaAssignmentList[0].assignmentTime);
      //   formData.append('escalationId[1]', feedbackDetailsResponse.receipt.departmentSlaEscalationList[1].slaId);
      //   formData.append('departmentSlaEscalationId[1]', feedbackDetailsResponse.receipt.departmentSlaEscalationList[1].departmentSlaEscalationId);
      //   formData.append('slaEscalationTime[1]', feedbackDetailsResponse.receipt.departmentSlaEscalationList[1].minuteToCalculate);
      //   formData.append('escalationGroupId[1]', feedbackDetailsResponse.receipt.departmentSlaEscalationList[1].asigneeGroupId);
      //   formData.append('warningTime', AppropriateDateComponent(feedbackDetailsResponse.receipt.departmentSlaEscalationList[0].escalationTime));
      //   formData.append('warningTimeInMinute', feedbackDetailsResponse.receipt.departmentSlaEscalationList[0].minuteToCalculate);
      //   formData.append('feedbackId', feedbackDetailsResponse.id);
      // }
      // else if(props.keyComponent === 'View'){
      //   formData.append('_csrf', csrfToken);
      //   formData.append('feedbackId', feedbackDetailsResponse[0].id);
      //   formData.append('comment.commentGiven', '');
      //   formData.append('fileName', '');
      //   formData.append('user.username', '');
      //   formData.append('_csrf', csrfToken);
      // }
      // else if(props.keyComponent === 'Close'){
      //   console.log(feedbackDetailsResponse);
      //   formData.append('_csrf', csrfToken);
      //   formData.append('feedbackId', '');
      //   formData.append('feedbackTypeDesc', feedbackDetailsResponse.feedbackType.description);
      //   formData.append('receiptTargetId', feedbackDetailsResponse.receipts.receiptTargetId);
      //   formData.append('departmentId', rolesId);
      //   formData.append('feedbackId', feedbackDetailsResponse.id);
      //   formData.append('comment', '');
      //   formData.append('_csrf', csrfToken);
      //   formData.append('fileName', '');
      //   formData.append('user.username', '');
      //   formData.append('departmentSlaId[0]', feedbackDetailsResponse.receipt.departmentSlaAssignmentList[0].departmentSlaId);
      //   formData.append('escalationId[0]', feedbackDetailsResponse.receipt.departmentSlaAssignmentList[0].slaId);
      //   formData.append('departmentSlaEscalationId[0]', feedbackDetailsResponse.departmentSlaEscalationList[0].departmentSlaEscalationId);
      //   formData.append('escalationGroupId[1]', feedbackDetailsResponse.receipt.departmentSlaEscalationList[0].asigneeGroupId);
      // }

      setCurrentStatus(feedbackDetailsResponse.status);

      setMap(feedbackDetailsResponse.feedbackDetails.tabVisibilityMap);

      setCloseData(() => {
        const temp = {
          ...feedbackDetailsResponse.feedbackDetails,
          latestReceipt: { ...feedbackDetailsResponse.receiptDetails[0] },
        };
        return temp;
      });

      console.log(feedbackDetailsResponse);
    }
    console.log(feedbackDetailsResponse);
  }, [feedbackDetailsResponse, currentStatus, map]);
  console.log(activeSection);
  const handleContactInfoClick = (id) => {
    // Your logic here using the id
    console.log("Clicked item id:", id);
    setPayloadProps((prevPayload) => {
      return { ...prevPayload, ["id"]: id };
    });
    // You can perform further actions based on the id
  };
  const Dashboardtoggle = () => {
    props.Dashboardtoggle();
    console.log("view");
  };
  const [mailListForCustomerResponse, setMailListForCustomerResponse] = useState([]);
    const MailList = (data) => {
    debugger;
    const newMails = [
    {
      autoGenerated: false,
      body: "<html><BODY><TABLE><tr><td><font style='font-weight: bold;'>Dear Sir/Madam,</font></td></tr></div><br/></td></tr><tr><td><font style='font-weight: bold;'>There is an update on Feedback #"+data.data.feedback.feedbackCode+" with details:</font></td></tr><div border=\"1\" style=\"height: auto;width: auto;border:1px solid black; padding: 10px;\"><html>\n <head></head>\n <body>\n  <p>"+data.data.feedback.commentGiven+"</p>\n </body>\n</html>",
      lastAttemptDate: data.data.feedback.createDate,
      mailBccStr: "",
      mailCCStr: "",
      mailFromStr: data.data.feedback.emailId,
      mailSentAttemptId: 0,
      mailToStr: "feedback@mjunction.in",
      mailType: "Feedback Updates Mail from Customer",
      referenceId: data.data.feedback.feedback_id,
      referenceTypeId: 106,
      sentAttemptNo: 0,
      serviceId: 0,
      subject: "Update on Feedback #"+data.data.feedback.feedbackCode,
      // attachment: [
      // {
      //   id: data.data.feedback.attachment_id,
      //   description: data.data.feedback.addFileList[0].description,
      //   fileName: data.data.feedback.addFileList[0].fileName,
      //   originalFileName: data.data.feedback.addFileList[0].originalFileName
      // }]
    }];
   if (data.data.feedback.addFileList && data.data.feedback.addFileList.length > 0) {
    newMails[0].attachment = [
      {
        id: data.data.feedback.attachment_id,
        description: data.data.feedback.addFileList[0].description,
        fileName: data.data.feedback.fileName,
        originalFileName: data.data.feedback.addFileList[0].originalFileName
      }
    ];
    }
    console.log("New mails being added:", newMails);
    // Append new entries while keeping existing ones
    setMailListForCustomerResponse((prevList) => [...prevList, ...newMails]);
    };
    useEffect(() =>{
      console.log("Empty useEffect"+ mailListForCustomerResponse);
    },[mailListForCustomerResponse]);
  return (
    <div className="wrapper">
      <Container fluid>
        <PageHeadContainer
          Dashboardtoggle={Dashboardtoggle}
          pageTitle={props.path[props.path.length - 1]}
          pathArray={props.path}
        ></PageHeadContainer>
        {/* <DashboardButtonCard ></DashboardButtonCard> */}
        {/* <HeaderCard title={"Feedback Details"} ></HeaderCard> */}
        <Row className="feedback-details-area g-3">
          <Col lg="9">
            <Card className="border-color-blue feedback-right h-100">
              {/* <Card.Header className={styles.customHeader}>
          <strong><h2>Feedback Details</h2></strong>
        </Card.Header> */}
              <Card.Body className="p-0">
                <Row className="h-100">
                  <Col className="">
                    {/* <div className={styles.mainContainer}>
                  <Box sx={{ width: '100%' }}>


                    <Tabs value={activeSection} onChange={(event, newValue) => toggleSection(newValue)} aria-label="basic tabs example">
                      {map[t('general.tab.feedbackDetails.text')] && <Tab value="0" label={t('general.tab.feedbackDetails.text')} sx={{ color: 'black' }} />}
                      {map[t('general.tab.receiptDetails.text')] && <Tab value="1" label={t('general.tab.receiptDetails.text')} sx={{ color: 'black' }} />}
                      {map[t('general.tab.resolutionDetails.text')] && <Tab value="2" label={t('general.tab.resolutionDetails.text')} sx={{ color: 'black' }} />}
                      {map[t('general.tab.slaDetails.text')] && <Tab value="3" label={t('general.tab.slaDetails.text')} sx={{ color: 'black' }} />}
                      {map[t('general.tab.customerSatisfaction.text')] && <Tab value="4" label={t('general.tab.customerSatisfaction.text')} sx={{ color: 'black' }} />}
                      {map[t('general.tab.commentDetails.text')] && <Tab value="5" label={t('general.tab.commentDetails.text')} sx={{ color: 'black' }} />}
                    </Tabs>

                  </Box>
                </div> */}
                    {renderActiveSection()}
                    {/* <FeedBackDetails data={feedbackDetailsResponse} /> */}
                  </Col>
                  {/* <Col lg="8" className='conversation-log ps-0'>
                <Card className='rounded-0 border-0 bg-transparent'>
                  <Card.Header className='fs-5 fw-medium bg-transparent border-color-blue'><i class="ti ti-notes"></i> Order Delay complaint heading</Card.Header>
                  <Card.Body>

                    <Card className='common-reply others-reply-card'>
                      <Card.Body className='p-2'>
                        <Row className='g-3'>
                          <Col lg="auto">
                            <div className='mail-profile'></div>
                          </Col>
                          <Col>
                            <p className='mail-date'>December 10, 2023 at 11:31a.m</p>
                            <h5 className='mail-sender-name fw-medium mt-2'>
                              mjunction replied
                            </h5>
                            <h6 className='fw-normal'>
                              <i className="ti ti-mail-forward me-2"></i>
                              <span className='fw-medium'>To: </span>
                              <span className='mail-id'>abhishek.chakladar@mail.in</span>
                            </h6>
                            <h6 className='mail-subject mb-3'>Subject: dummy text heading</h6>
                            <p className='mail-body mb-0'>
                              Hi Abhishek Chakladar,
                              <br></br>
                              Congratulations! am has received your complaint.
                              <br></br>
                              Best Regards
                            </p>

                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                    <Card className='common-reply others-reply-card'>
                      <Card.Body className='p-2'>
                        <Row className='g-3'>
                          <Col lg="auto">
                            <div className='mail-profile'></div>
                          </Col>
                          <Col>
                            <p className='mail-date'>December 10, 2023 at 11:31a.m</p>
                            <h5 className='mail-sender-name fw-medium mt-2'>
                              mjunction replied
                            </h5>
                            <p className='mail-body mb-0'>
                              Hi Abhishek Chakladar,
                              Congratulations! am has received your complaint.
                              Best Regards
                            </p>

                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                    <Card className='common-reply auto-reply-card'>
                      <Card.Body className='p-2'>
                        <Row className='g-3'>
                          <Col lg="auto">
                            <div className='mail-profile'></div>
                          </Col>
                          <Col>
                            <p className='mail-date'>December 10, 2023 at 11:31a.m</p>
                            <h5 className='mail-sender-name fw-medium mt-2'>
                              mjunction auto replied - New Ticket
                            </h5>
                            <h6 className='fw-normal'>
                              <i className="ti ti-mail-forward me-2"></i>
                              <span className='fw-medium'>To: </span>
                              <span className='mail-id'>abhishek.chakladar@mail.in</span>
                            </h6>
                            <h6 className='mail-subject mb-3'>Subject: dummy text heading</h6>
                            <p className='mail-body mb-0'>
                              Hi Abhishek Chakladar,
                              <br></br>
                              We apologize for your recent poor experience. An agent will reach out to you prompt to address your concerns.
                              <br></br>
                              Best Regards
                            </p>

                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                    <Card className='common-reply creator-card'>
                      <Card.Body className='p-2'>
                        <Row className='g-3'>
                          <Col lg="auto">
                            <div className='mail-profile'></div>
                          </Col>
                          <Col>
                            <p className='mail-date'>December 10, 2023 at 11:31a.m</p>
                            <h5 className='mail-sender-name fw-medium mt-2'>
                              Abhishek Chakladar
                            </h5>
                            <h6 className='fw-normal'>
                              <i className="ti ti-mail-forward me-2"></i>
                              <span className='fw-medium'>To: </span>
                              <span className='mail-id'>support@mail.in</span>
                            </h6>
                            <h6 className='mail-subject mb-3'>Subject: dummy text heading</h6>
                            <p className='mail-body mb-0'>
                              Hello,
                              <br></br>
                              I place an order on 1st of Dec. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s.
                              <br></br>
                              Thank you,
                              <br></br>
                              Abhishek
                            </p>
                            <div className='attachments'>

                              <a className='file text-decoration-none mt-2' href='#'>
                                <img src={AttachmentFile}></img>
                                <div className='file-details mx-2 text-dark'>
                                  <h6 className='file-name mb-1'>File_name.pdf</h6>
                                  <p className='file-size mb-0'>34 KB</p>
                                </div>
                                <i class="ti ti-download fs-4 text-secondary"></i>
                              </a>

                              <a className='file text-decoration-none mt-2' href='#'>
                                <img src={AttachmentFile}></img>
                                <div className='file-details mx-2 text-dark'>
                                  <h6 className='file-name mb-1'>File_name.pdf</h6>
                                  <p className='file-size mb-0'>34 KB</p>
                                </div>
                                <i class="ti ti-download fs-4 text-secondary"></i>
                              </a>

                            </div>

                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                  </Card.Body>
                </Card>

              </Col> */}
                  <MailReply
                    data={feedbackDetailsResponse}
                    onMailOpen={onMailOpen}
                    mail={mailId}
                    customerResponseData= {mailListForCustomerResponse}
                    feedbackid={props.body.id}
                  ></MailReply>
                </Row>
              </Card.Body>
            </Card>

            {(role === "ROLE_SPOC" || role === "ROLE_RESOLVER") &&
              props.keyComponent === "Accept" && (
                <Card className={styles.customCard}>
                  {showAcceptbackCloser && (
                    <AcceptFeedback
                      data={feedbackDetailsResponse}
                      onClose={handleModalClose}
                    />
                  )}
                  {lastopen && (
                    <Snackbar
                      open={lastopen}
                      autoHideDuration={5000}
                      onClose={lasthandleClose}
                      message={snackbarMessage}
                      action={action}
                    />
                  )}
                  {showFeedbackCloser && <FeedbackClosure />}
                </Card>
              )}

            {props.renderComponent && currentStatus !== "R" && (
              <div>
                <Card className={styles.customCard}>
                  <Card.Header className={styles.customHeader}>
                    <strong>
                      <h2>Feedback Closure</h2>
                    </strong>
                  </Card.Header>
                  <Card.Body className={styles.customBody}>
                    {props.renderComponent(formData)}
                  </Card.Body>
                </Card>
              </div>
            )}
          </Col>

          <Col lg="3">
            <Card className="person-all-info h-100">
              <CardBody>
                <ContactInfo
                  data={feedbackDetailsResponse}
                  latestInfo={props.latestFeedbackDetails}
                  onClick={handleContactInfoClick}
                ></ContactInfo>

                {/* <div className='section history-info'>
              <h5 className='card-title mb-3'>History</h5>
              <ul class="timeline">
                <li class="timeline-item">
                  <div class="timeline-body">
                    <div class="timeline-content">
                      <Card className="border-0">
                        <CardBody className="p-0">
                          <h6 className='fw-normal'>
                            <i className="ti ti-mail-forward me-2"></i>
                            <span className='fw-medium'>To: </span>
                            <span className='mail-id'>abhishek.chakladar@mail.in</span>
                          </h6>
                          <h6 className='fw-medium mb-2 fs-5'>System generated mail</h6>
                          <p className='text-secondary'>December 10, 2023 at 11:31a.m</p>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </li>

                <li class="timeline-item">
                  <div class="timeline-body">
                    <div class="timeline-content">
                      <Card className="border-0">
                        <CardBody className="p-0">
                          <h6 className='fw-normal'>
                            <i className="ti ti-mail-forward me-2"></i>
                            <span className='fw-medium'>To: </span>
                            <span className='mail-id'>support@mail.in</span>
                          </h6>
                          <h6 className='fw-medium mb-2 fs-5'>I place an order on 1st of Dec. Lorem.... </h6>
                          <p className='text-secondary'>December 10, 2023 at 11:30a.m</p>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </li>

              </ul>
            </div> */}
                <Historytimeline
                  data={feedbackDetailsResponse}
                  mailOpen={mailOpen}
                ></Historytimeline>
                {/* <div className='section attachment-info'>
              <h5 className='card-title mb-1'>Attachment</h5>
              <div className='attachments'>

                <a className='file text-decoration-none mt-2' href='#'>
                  <img src={AttachmentFile}></img>
                  <div className='file-details mx-2 text-dark'>
                    <h6 className='file-name mb-1'>File_name.pdf</h6>
                    <p className='file-size mb-0'>34 KB</p>
                  </div>
                  <i class="ti ti-download fs-4 text-secondary"></i>
                </a> */}

                {/* <a className='file text-decoration-none mt-2' href='#'>
                  <img src={AttachmentFile}></img>
                  <div className='file-details mx-2 text-dark'>
                    <h6 className='file-name mb-1'>File_name.pdf</h6>
                    <p className='file-size mb-0'>34 KB</p>
                  </div>
                  <i class="ti ti-download fs-4 text-secondary"></i>
                </a> */}

                {/* <a className='file text-decoration-none mt-2' href='#'>
                  <img src={AttachmentFile}></img>
                  <div className='file-details mx-2 text-dark'>
                    <h6 className='file-name mb-1'>File_name.pdf</h6>
                    <p className='file-size mb-0'>34 KB</p>
                  </div>
                  <i class="ti ti-download fs-4 text-secondary"></i>
                </a> */}

                {/* </div>
            </div> */}
                {/* <AttachmentFileDetails data={feedbackDetailsResponse}></AttachmentFileDetails> */}
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* {showRate && <CustomerSatisfaction data={feedbackDetailsResponse}></CustomerSatisfaction>} */}

        {isShowingModal && (
          <ReactModal
            componentToRender={
              <ViewFeedbackDetails
                fetchUrl={getCustomerFeedbackDetailsURL}
                body={taggedPayload}
              />
            }
            show={isShowingModal}
            handleClose={toggleModal}
            title={t("general.lable.feedbackDetail.text   ")}
            size="xl"
            additionalButtonAction={handleAdditionalButtonAction}
            toggleModal={toggleModal}
            fullscreen
            parentbutton
          ></ReactModal>
        )}

        <ReactModal
          componentToRender={
            <CommentDetails
              data={feedbackDetailsResponse}
              consentDetails={consentDetails}
              consentTaggeddata={consentTagged}
              consentID={CosnetTaggedId}
            />
          }
          show={isShowing}
          handleClose={toggle}
          title={t("general.label.comment.details")}
        ></ReactModal>

        <ReactModal
          componentToRender={
            <ReceiptDetails
              data={feedbackDetailsResponse}
            // consentDetails={consentDetails}
            // consentTaggeddata={consentTagged}
            // consentID={CosnetTaggedId}
            />
          }
          size="xl"
          show={reciptResponse}
          handleClose={setReciptResponse}
          title={t("general.tab.receiptDetails.text")}
        ></ReactModal>
        <ReactModal
          componentToRender={
            <SlaDetails
              data={feedbackDetailsResponse}
            // consentDetails={consentDetails}
            // consentTaggeddata={consentTagged}
            // consentID={CosnetTaggedId}
            />
          }
          size="xl"
          show={slaDetails}
          handleClose={setSladetailstoggle}
          title={t("general.tab.slaDetails.text")}
        ></ReactModal>
        <ReactModal
          show={closeFd}
          handleClose={closeFeedbackToggle}
          componentToRender={
            <CloseFeedback
              onModalCloseHandler={() => {
                document.querySelector("#IamDoraemon .btn-close").click();
              }}
              snackBarSwitch={setLastOpen}
              snackMsg={setSnackbarMessage}
              isUsedWithModal
              dataUsedWithModal={closeData}
              needsRefresh={true}
            />
          }
          title={"Close Feedback"}
          size={"lg"}
          modalId={"IamDoraemon"}
        />
        <ReactModal
          componentToRender={
            <ResolutionDetails data={feedbackDetailsResponse} />
          }
          size="xl"
          show={resolutionModal}
          handleClose={setResolutionModal}
          title={t("general.tab.resolutionDetails.text")}
        ></ReactModal>
        <ReactModal
          componentToRender={
            <CustomerSatisfactionResponse
              data={feedbackDetailsResponse}
            ></CustomerSatisfactionResponse>
          }
          show={customerSatisfactionResponse}
          handleClose={setCustomerSatisfactionResponse}
          title={t("general.tab.customerSatisfaction.text")}
        ></ReactModal>
        <ReactModal
          modalId={"SatisfactionId"}
          componentToRender={
            <CustomerSatisfaction
              lastOpen={snackbarSwitch}
              setSnackbarSwitch={setSnackbarSwitch}
              setSnackbarMessage={setSnackbarMessage1}
              onModalCloseHandler={() => {
                document.querySelector("#SatisfactionId .btn-close").click();
              }}
              data={feedbackDetailsResponse}
            ></CustomerSatisfaction>
          }
          show={showRate}
          handleClose={setRate}
          title={t("general.tab.customerSatisfaction.text")}
        ></ReactModal>
        <PluginSnackbar
          open={snackbarSwitch}
          message={snackbarMessage1}
          onClose={() => {
            setSnackbarSwitch(false);
          }}
        />
      </Container>
    </div>
  );
};

export default ViewFeedbackDetails;
